import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'
import { ViewableBy } from '../utilities/viewable-check'

export const RichTextBlockFragment: BlockFragment = {
  name: 'richText',
  fragment: gql`
    fragment richText on RichText {
      id
      blockName
      blockType
      alignment
      richText
      expandable
      richTextMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        web
        android
      }
    }
  `,
  partialFragment: `
    ...on RichText {
      id
      blockName
      blockType
      alignment
      richText
      expandable
      richTextMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        web
        android
      }
    }
  `,
}

export const RichTextBlockType = 'richText'

export interface RichTextBlock extends BaseBlock {
  blockType: typeof RichTextBlockType
  alignment: 'left' | 'center' | 'right'
  richText: string
  expandable?: boolean
  richTextMeta?: {
    viewableBy: [ViewableBy]
  }
}
